import axios from "axios";

const getStaticPage = async (pageKey) => {
  return await axios({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/static-page/${pageKey}`,
  });
};

export { getStaticPage };
